<div mat-dialog-actions class="d-flex align-items-center my-account-mobile-dialog-actions">
  <h1>Menu</h1>
  <button class="btn btn-link p-0 border-0">
    <mat-icon class="material-icons-sharp light md-16" (click)="closeMyAccountMobileDialog()">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="my-account-mobile-dialog-content">
  <!-- My Account Menu -->
  @for (myAccountNav of myAccountLinksOverride || myAccountLinks; track myAccountNav) {
  <div class="my-account-mobile-dialog-content-list">
    @if (myAccountNav.children) {
    <mat-list-item (click)="onClickSubMenu($event, 0)" disableRipple>
      <mat-icon class="material-icons-sharp light">menu</mat-icon>
      <mat-icon class="material-icons-sharp light ml-auto menu-button" [class.rotated]="showSubSubMenu[0]"
        >expand_more</mat-icon
      >
    </mat-list-item>
    } @if (myAccountNav.children && showSubSubMenu[0]) {
    <div class="submenu-container" [class.expanded]="showSubSubMenu[0]" [class.d-none]="!showSubSubMenu[0]">
      @for (myAccountNavChild of myAccountNav.children; track myAccountNavChild) {
      <div class="subsubmenu-container d-xl-none">
        @if (myAccountNavChild.url) {
        <mat-list-item
          (click)="onClick(myAccountNavChild.url, myAccountNavChild.styleClasses)"
          disableRipple
          [class.hidden]="myAccountNavChild.url === '/dealer-selection' && !asmEnabled"
        >
          <span class="submenu">{{ myAccountNavChild.title | titlecase }}</span>
        </mat-list-item>
        }
      </div>
      }
    </div>
    }
  </div>
  }
  <!-- Header Links -->
  @for (headerLinkComponent of headerLinksMobileNavEntries; track headerLinkComponent) {
  <div class="my-account-mobile-dialog-content-list">
    <mat-list-item (click)="onClick(headerLinkComponent.url)" disableRipple>
      <span class="submenu">{{ headerLinkComponent.linkName | titlecase }}</span>
    </mat-list-item>
  </div>
  }
  <!-- Languages -->
  @for (languageNav of languageMobileNavNode; track languageNav) {
  <div class="my-account-mobile-dialog-content-list" [class.no-flags]="!(isLanguageFlagIconEnabled$ | async)">
    @if (languageNav.children) {
    <mat-list-item (click)="onClickSubMenu($event, 1)" disableRipple>
      @if (languageNav.title === 'My Account') {
      <mat-icon class="material-icons-sharp light">menu</mat-icon>
      } @if (languageNav.title === 'Languages' && activeLanguageCountryIsocode) {
      <span
        class="flag:{{
          (isCountryFlagInsteadEnabled$ | async) ? (activeCountry$ | async | uppercase) : activeLanguageCountryIsocode
        }} mr-2"
      ></span>
      } @if (languageNav.title === 'Languages') {
      <span class="submenu">{{ activeLanguageName | titlecase }}</span>
      }
      <mat-icon class="material-icons-sharp light ml-auto menu-button" [class.rotated]="showSubSubMenu[1]"
        >expand_more</mat-icon
      >
    </mat-list-item>
    } @if (languageNav.children && showSubSubMenu[1]) {
    <div class="submenu-container" [class.expanded]="showSubSubMenu[1]" [class.d-none]="!showSubSubMenu[1]">
      @for (languageNavChild of languageNav.children; track languageNavChild) {
      <div class="subsubmenu-container d-xl-none">
        @if (languageNavChild.url) {
        <mat-list-item (click)="onClick(languageNavChild.url)" disableRipple>
          <span class="submenu">{{ languageNavChild.title | titlecase }}</span>
        </mat-list-item>
        } @if (languageNavChild.isocode) {
        <mat-list-item
          (click)="setShimanoActiveLanguage(languageNavChild.isocode); closeMyAccountMobileDialog()"
          disableRipple
        >
          <span
            class="flag:{{
              (isCountryFlagInsteadEnabled$ | async)
                ? (activeCountry$ | async | uppercase)
                : languageNavChild.country.isocode
            }} mr-1"
          ></span>
          <span class="subsubmenu" [class.selected]="activeLanguageIsocode === languageNavChild.isocode">{{
            languageNavChild.name | titlecase
          }}</span>
          @if (activeLanguageIsocode === languageNavChild.isocode) {
          <mat-icon svgIcon="check" class="ml-auto md-12 dark"></mat-icon>
          }
        </mat-list-item>
        }
      </div>
      }
    </div>
    }
  </div>
  }
</div>
